import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function PositionedSnackbar({ openStatus, onCloseFunction, message, severity }) {
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;

  useEffect(() => {
    if (openStatus) {
      const timer = setTimeout(() => {
        onCloseFunction(false);
      }, 5000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [openStatus, onCloseFunction]);

  const handleClose = () => {
    onCloseFunction(false);
  };

  return (
    <Box sx={{ width: 500 }}>
  <Snackbar
    anchorOrigin={{ vertical, horizontal }}
    open={openStatus}
    onClose={handleClose}
    key={vertical + horizontal}
  >
    <Alert
      onClose={handleClose}
      severity={severity}
      variant="filled"
      sx={{
        width: "100%",
        color: "#fff",
        background:
          "linear-gradient(135deg, #1a0f12 0%, #2b1016 100%)",
        border: "1px solid #e63946",
        borderRadius: "16px",
        boxShadow: "0 8px 25px rgba(230,57,70,0.25)",

        "& .MuiAlert-icon": {
          color: "#e63946",
        },

        "& .MuiAlert-action": {
          color: "#fff",
        },
      }}
    >
      {message}
    </Alert>
  </Snackbar>
</Box>
  );
}